import { render, staticRenderFns } from "./TokenView.vue?vue&type=template&id=223451e0&scoped=true&"
import script from "./TokenView.vue?vue&type=script&lang=js&"
export * from "./TokenView.vue?vue&type=script&lang=js&"
import style0 from "./TokenView.vue?vue&type=style&index=0&id=223451e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223451e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VBtn,VCol,VContent,VForm,VRow})
